// @ts-check
const COOKIE_NAME = 'disabled_global_site_banners'
const STYLE_ELEMENT_ID = 'global-banner-disable-styles'

// The dismissal cookie is user-controlled, so restrict UIDs to a safe charset before using them in
// a CSS selector to avoid injection.
const SAFE_UID = /^[a-zA-Z0-9_-]+$/

/**
 * Hides previously-dismissed banners before first paint by injecting a stylesheet, so the hide is
 * unaffected by later client-side rendering of the banner elements.
 */
export function hideDismissedBanners() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}\\s*=\\s*([^;]+)`))
  const cookie = match ? match[1] : null
  const uids = cookie
    ? cookie
        .split(',')
        .map(uid => uid.trim())
        .filter(uid => SAFE_UID.test(uid))
    : []

  // Use an attribute selector rather than `#id` so UIDs that are not valid CSS identifiers (e.g. a
  // leading digit) still match. The safe charset guarantees the value cannot break out of the quotes.
  const rules = uids.map(uid => `global-banner[id="${uid}"]{display:none !important}`).join('')

  let style = document.getElementById(STYLE_ELEMENT_ID)
  if (!rules) {
    style?.remove()
    return
  }

  if (!style) {
    style = document.createElement('style')
    style.id = STYLE_ELEMENT_ID
    document.head.appendChild(style)
  }
  style.textContent = rules
}
